import {
  APP_ZONES,
  HookAction,
  RelevantBaasTags,
  Role,
  SupportedDevice,
  WidgetNames,
  WorkflowPageConfig,
  WorkflowZoneDevicesConfig,
} from '@finxone-platform/shared/sys-config-types';
import { profileConfirmPageConfig } from '../pages/verification.pages';
import { generateOnboardingWidgetsWorkflowWidgetConfig } from '../widgets/onboarding/onboarding.type';

// hook function looked up at runtime as can't be stored in config
export const roleHooks: {
  [key: string]: (
    roleConfig: Role,
    device: SupportedDevice,
    subscription: string,
    action: HookAction,
    relevantBaasTags: RelevantBaasTags[],
  ) => Role;
} = {
  'verification-profile-widget-page-hook': (role, device, subscription, action) => {
    if (action == 'add') {
      addWidgetsToVerificationConfirmPage(role, device, subscription);
    }
    return role;
  },
};

function addWidgetsToVerificationConfirmPage(role: Role, device: SupportedDevice, subscription: string) {
  const verificationZone = role.zones[APP_ZONES.VERIFICATION]?.canvases.subscription[
    subscription
  ] as WorkflowZoneDevicesConfig;
  const page = verificationZone[device]?.pages.find((page) => page.name === profileConfirmPageConfig.name);
  if (page) {
    const newWidgets = [
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.BIRTHDAY_WIDGET),
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.ADDRESS_WIDGET),
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.PHONE_WIDGET),
      generateOnboardingWidgetsWorkflowWidgetConfig(WidgetNames.EMAIL_WIDGET),
    ];
    // push new widgets and recalculate y positions for widgets
    newWidgets.forEach((widget) => {
      const widgetsLength = page.widgets.push(widget);
      // Push added widget to bottom of page on y axis
      if (widgetsLength) checkAddWidgetGridPosition(widgetsLength - 1, page);
    });
  }
}

// push widget at widgetIndex to new greatest y position
function checkAddWidgetGridPosition(widgetIndex: number, pageConfig: WorkflowPageConfig) {
  if (!pageConfig.pageConfiguration.isUsingHtmlStructure) {
    const max = pageConfig.widgets.reduce((prev, current) => {
      // Check if both widgets have gridPosition defined
      if (!prev.gridPosition || !current.gridPosition) {
        throw new Error('gridPosition must be defined for this widget');
      }

      return prev.gridPosition.y > current.gridPosition.y ? prev : current;
    });

    // Since we know max will have gridPosition (due to the check above), we can assert it
    if (!max.gridPosition) {
      return;
    }

    const targetWidget = pageConfig.widgets[widgetIndex];
    // Ensure the target widget has gridPosition
    if (!targetWidget.gridPosition) {
      return;
    }

    targetWidget.gridPosition.y =
      widgetIndex === 0 ? max.gridPosition.y : max.gridPosition.y + max.gridPosition.rows;
  }
}
